import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Outlet } from "react-router-dom"
import { FooterWithSteps } from "../components/Footer"
import Header from "../components/Header"
import Loader from "../components/Loader"
import othersActions from "../redux/actions/others"
import { useAgenda } from "../routes/Agenda/customHooks"

export const AppLayout = () => {
  const isLoading = useSelector(state => state.others.isLoading)
  const dispatch = useDispatch()
  const isModalUserData = useSelector(state => state.others.isModalUserData)
  const setModalUserData = (value) => dispatch(othersActions.setModalUserData(value))
  const [showUserInfo, setShowUserInfo] = useState(false)
  const data = {isModalUserData, setModalUserData, showUserInfo, setShowUserInfo}
  return (
    <div className="min-h-screen flex flex-col">
      {isLoading && <div className='absolute'><Loader /></div>}
      <Header data={{...data}} />
      <div className="min-h-[90vh]"><Outlet /></div>
    </div>
    
    )
  }
  
export const ScheduleLayout = () => {
  const generalData = useAgenda();
  return (
    <>
      <main className="lg:min-h-[77vh] pb-8 lg:pb-0 px-3 sm:px-6 md:px-9 w-full pt-10">
        <Outlet context={{ ...generalData }} />
      </main>
      <div className="w-full flex justify-center lg:justify-end lg:h-[12vh]">
        <FooterWithSteps steps />
      </div>
    </>
  );
}
